import Footer from "../components/Footer";
import HomePageWallpaper from "../components/HomePageWallpaper";
import OurHappyClients from "../components/OurHappyClients";

export default function Home() {
  return (
    <div className="main_basket">
      <HomePageWallpaper />
      <div className="main_basket_child">
        <div className="small_basket intro">
          <p>
            <span className="span_style_type1">Hello! viewer?</span> Welcome to
            our website. Here at{" "}
            <span className="span_style_type2">Socca ReactApp</span> we care
            much about your success in digital technology. We are going to
            listen to you and provide you with a best digital solutions.
          </p>
          <p>
            Here we create websites, web applications and other software
            solutions that meets your needs
          </p>
        </div>
        <OurHappyClients />
      </div>
      <Footer />
    </div>
  );
}
